// tslint:disable:max-line-length

export interface IAction<P = any> { T: string; P?: P; }

export type ActionCreator<A extends IAction> = (payload?: A['P']) => { type: A['T'], payload: A['P'] };

export function createActionCreators<A extends IAction, B extends IAction, C extends IAction, D extends IAction, E extends IAction>(...types: Array<A['T'] | B['T'] | C['T'] | D['T'] | E['T']>): {
	[key in A['T'] | B['T'] | C['T'] | D['T'] | E['T']]: ActionCreator<key extends A['T'] ? A : key extends B['T'] ? B : key extends C['T'] ? C : key extends D['T'] ? D : E>
};
export function createActionCreators<A extends IAction, B extends IAction, C extends IAction, D extends IAction>(...types: Array<A['T'] | B['T'] | C['T'] | D['T']>): {
	[key in A['T'] | B['T'] | C['T'] | D['T']]: ActionCreator<key extends A['T'] ? A : key extends B['T'] ? B : key extends C['T'] ? C : D>
};
export function createActionCreators<A extends IAction, B extends IAction, C extends IAction>(...types: Array<A['T'] | B['T'] | C['T']>): {
	[key in A['T'] | B['T'] | C['T']]: ActionCreator<key extends A['T'] ? A : key extends B['T'] ? B : C>
};
export function createActionCreators<A extends IAction, B extends IAction>(...types: Array<A['T'] | B['T']>): {
	[key in A['T'] | B['T']]: ActionCreator<key extends A['T'] ? A : B>
};
export function createActionCreators<A extends IAction>(...types: Array<A['T']>): {
	[key in A['T']]: ActionCreator<A>
};
export function createActionCreators<A extends IAction>(...types: Array<A['T']>): { [key in A['T']]: ActionCreator<A> } {
	return types.reduce((all, type) => {
		all[type] = (payload) => ({ type, payload });
		return all;
	}, {} as { [key in A['T']]: ActionCreator<A> });
}

export type ActionValues<T extends { [key: string]: () => any }> = ({ [key in keyof T]: ReturnType<T[key]> });
export type ActionTypeNames<T extends { [key: string]: any }> = { [key in keyof T]: key };
